import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 46 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46 14\" id=\"arrow-left\">\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke-width=\"2\">\n    <path stroke=\"currentColor\" d=\"M2 7h44\" />\n    <path stroke=\"currentColor\" d=\"M8 1L2 7l6 6\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol